import { cloneDeep, get } from 'lodash'

import { getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'
import { DOCUMENT_TEMPLATES_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { DEFAULT_INVOICE_PAYLOAD, getStorageURL, globalErrorHandler, request, services } from '@/utils'

import render from './render'

const invoicesPathToAPI = getServicePathToAPI(services.invoices)
const pathToAPI = getServicePathToAPI(services.documentTemplates)

export default {
  name: 'DocumentTemplatesGenerateButton',

  props: {
    OwnerId: String,
    ResellerId: String
  },

  data() {
    return {
      loading: false,
      showDialog: false,
      formValidation: false,

      type: DOCUMENT_TEMPLATES_TYPES.invoice,
      payload: cloneDeep(DEFAULT_INVOICE_PAYLOAD)
    }
  },

  watch: {
    OwnerId() {
      this.payload.customerId = this.OwnerId
    },

    $route: {
      handler() {
        this.showDialog = false
      },
      deep: true
    }
  },

  mounted() {
    this.payload.customerId = this.OwnerId
  },

  beforeDestroy() {
    this.payload = cloneDeep(DEFAULT_INVOICE_PAYLOAD)
  },

  methods: {
    async generate() {
      try {
        this.loading = true
        switch (this.type) {
          case DOCUMENT_TEMPLATES_TYPES.contract: {
            const data = await request.find(joinURLPath(pathToAPI, 'generate'), undefined, {
              type: DOCUMENT_TEMPLATES_TYPES.contract,
              companyId: this.payload.companyId,
              requisiteId: this.payload.requisiteId
            })
            if (data) {
              window.location.href = getStorageURL([ get(data, 'Owner.id', data.OwnerId), data.id ])
              this.showDialog = false
            }
            break
          }
          case DOCUMENT_TEMPLATES_TYPES.invoice: {
            const data = await request.create(invoicesPathToAPI, { body: this.payload }, { scopes: [ 'awaitDocument' ] })
            if (data) {
              window.location.href = getStorageURL([ get(data, 'Owner.id', data.OwnerId), data.documentId ])
              this.showDialog = false
            }
            break
          }
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
